import React, { useState, useEffect } from 'react';
import '../css/header.css';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Change background when scrolled past hero section (approximately 100vh)
      setIsScrolled(scrollPosition > window.innerHeight * 0.8);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Close dropdown when menu is toggled
    if (isMenuOpen) {
      setIsProductsDropdownOpen(false);
    }
  };

  const toggleProductsDropdown = () => {
    setIsProductsDropdownOpen(!isProductsDropdownOpen);
  };

  const handleNavLinkClick = () => {
    // Close menu on mobile when nav link is clicked
    if (window.innerWidth <= 768) {
      setIsMenuOpen(false);
      setIsProductsDropdownOpen(false);
    }
  };

  const products = [
    'Gate Valves',
    'Globe Valves',
    'Swing Check Valves',
    'Dual Plate Check Valves',
    'Butterfly Valves'
  ];

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <img src="/logo1-removebg-preview.png" alt="ANU Flow Control Logo" className="logo-image" />
            </Link>
            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
              <ul className="nav-list">
                <li><Link to="/" className="nav-link" onClick={handleNavLinkClick}>Home</Link></li>
                <li><Link to="/about" className="nav-link" onClick={handleNavLinkClick}>About</Link></li>
                <li><Link to="/industries-served" className="nav-link" onClick={handleNavLinkClick}>Industries Served</Link></li>
                <li className="nav-item-with-dropdown">
                  <div 
                    className="dropdown-wrapper"
                    onMouseEnter={() => window.innerWidth > 768 && setIsProductsDropdownOpen(true)}
                    onMouseLeave={() => window.innerWidth > 768 && setIsProductsDropdownOpen(false)}
                  >
                    <span 
                      className={`nav-link ${isProductsDropdownOpen ? 'nav-link-active' : ''}`}
                      onClick={toggleProductsDropdown}
                      style={{ cursor: 'pointer' }}
                    >
                      Products
                      <span className="dropdown-arrow"></span>
                    </span>
                    {isProductsDropdownOpen && (
                      <div className="dropdown-menu">
                      <Link 
                        to="/gate-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                        Gate Valves
                      </Link>
                      <Link 
                        to="/butterfly-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                        Butterfly Valves
                      </Link>
                      <Link 
                        to="/globe-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                        Globe Valves
                      </Link>
                      <Link 
                        to="/swing-check-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                         Swing Check Valves
                      </Link>
                      <Link 
                        to="/dual-plate-check-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                        Dual Plate Check Valves
                      </Link>
                      <Link 
                        to="/trunnion-ball-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                        Trunnion Mounted Ball Valves
                      </Link>
                      <Link 
                        to="/floating-ball-valves" 
                        className="dropdown-item"
                        onClick={handleNavLinkClick}
                      >
                        Floating Ball Valves
                      </Link>
                      </div>
                    )}
                  </div>
                </li>
                <li><Link to="/why-anuflowcontrol" className="nav-link" onClick={handleNavLinkClick}>Why AnuFlowControls</Link></li>
                <li><Link to="/contact" className="nav-link" onClick={handleNavLinkClick}>Contact</Link></li>
              </ul>
            </nav>
            <button className="menu-toggle" onClick={toggleMenu}>
              <span className="hamburger"></span>
              <span className="hamburger"></span>
              <span className="hamburger"></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
